import { LoginClearPreloadedData } from '../login/types';
import * as Bixby from './../../core';

export interface ProfileState {
  profile?: Bixby.Models.Profile;
  isLoading: boolean;
  loadingError?: Bixby.Models.BixbyError;
}

export const PROFILE_LOADING = 'PROFILE_LOADING';
export const PROFILE_SUCCESS = 'PROFILE_SUCCESS';
export const PROFILE_FAILURE = 'PROFILE_FAILURE';
export const PROFILE_SET_STATUS = 'PROFILE_SET_STATUS';

interface ProfilesLoading extends Bixby.Models.BixbyAction<undefined, typeof PROFILE_LOADING> {
  type: typeof PROFILE_LOADING;
}

interface ProfilesSuccess extends Bixby.Models.BixbyAction<Bixby.Models.Profile, typeof PROFILE_SUCCESS> {
  type: typeof PROFILE_SUCCESS;
  payload: Bixby.Models.Profile;
}

interface ProfilesFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof PROFILE_FAILURE> {
  type: typeof PROFILE_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface ProfileSetStatus extends Bixby.Models.BixbyAction<Bixby.Enums.UserStatus, typeof PROFILE_SET_STATUS> {
  type: typeof PROFILE_SET_STATUS;
  payload: Bixby.Enums.UserStatus;
}

export type ProfileActionTypes = ProfilesLoading | ProfilesSuccess | ProfilesFailure | ProfileSetStatus | LoginClearPreloadedData;
